import { render, staticRenderFns } from "./PackGoods.vue?vue&type=template&id=718fffe2"
import script from "./PackGoods.vue?vue&type=script&lang=js"
export * from "./PackGoods.vue?vue&type=script&lang=js"
import style0 from "./PackGoods.vue?vue&type=style&index=0&id=718fffe2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports